<template>
  <v-dialog v-model="dialog" max-width="450" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        block
        v-on="on"
        v-bind="attrs"
        class="mt-3"
        color="success"
        rounded
        :disabled="lista_itens.length == 0"
        >Emitir pedido</v-btn
      >
    </template>
    <v-card>
      <template v-if="pedidoEmitido.id > 0">
          <card-pedido-finalizado-insumos :id="pedidoEmitido.id" />
      </template>
       <template v-else> 
        <v-card-title>Emitir Pedido</v-card-title>
        <v-card-text class="subtitle-1">
          Confirmar o pedido para o cooperado
          {{ lista_itens.length > 0 ? lista_itens[0].cliente.nome : "" }}
          ??</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            rounded
            color="success"
            @click="finalizarPedido()"
            :loading="emitindoPedido"
            >Sim, emitir pedido</v-btn
          >
          <v-btn text rounded @click="dialog = false">Não, cancelar</v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CardPedidoFinalizadoInsumos from '../cards/CardPedidoFinalizadoInsumos.vue';
export default {
  components: { CardPedidoFinalizadoInsumos },
  computed: mapState("insumos", ["lista_itens", "emitindoPedido"]),
  data: () => ({
    dialog: false,
    pedidoEmitido: {id: 0}
  }),
  methods: {
    ...mapActions("insumos", ["emitirPedido"]),
    isMobile() {
      return this.$mq == "sm";
    },
    async finalizarPedido() {
      const ret = await this.emitirPedido();
      if (ret.success) {
        /*if (this.isMobile()) {
          this.$router.push(
            `/novo-pedido-insumos/finalizado/${ret.data.pedido}`
          );
        } else {*/
          this.pedidoEmitido.id = ret.data.pedido
        //}
      }
    },
  },
};
</script>

<style>
</style>